import React, { useState } from "react";
import api from "../api/api";
import { useNavigate, Link } from "react-router-dom";
import "../styles/Dashboard.css"; // Reaproveita estilos de modal e botões

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Chama o POST /api/users/ configurado na ViewSet
      await api.post("users/", { username, email, password });
      alert("Conta criada com sucesso! Agora faça o login.");
      navigate("/login");
    } catch (err) {
      console.error(err);
      const errorMsg = err.response?.data?.username?.[0] || "Erro ao cadastrar usuário.";
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal" style={{ background: "#2c3e50" }}>
      <form onSubmit={handleRegister} className="modal-content" style={{ width: "350px" }}>
        <h2 style={{ marginBottom: "20px" }}>📝 Criar Conta</h2>
        
        <input
          type="text"
          placeholder="Nome de Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{ marginBottom: "10px", width: "100%" }}
        />
        
        <input
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ marginBottom: "10px", width: "100%" }}
        />
        
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ marginBottom: "20px", width: "100%" }}
        />

        <div className="modal-actions" style={{ flexDirection: "column", gap: "10px" }}>
          <button 
            type="submit" 
            className="btn" 
            style={{ backgroundColor: "#2ecc71", color: "white", width: "100%" }}
            disabled={loading}
          >
            {loading ? "Cadastrando..." : "Registrar"}
          </button>
          
          <Link to="/login" style={{ fontSize: "14px", color: "#34495e", textDecoration: "none" }}>
            Já tem uma conta? Faça Login
          </Link>
        </div>
      </form>
    </div>
  );
}